import React, { useState, useEffect } from 'react';
import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemText,
    Chip,
    Stack,
    Box,
    Button,
    useTheme,
} from '@mui/material';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingTransactionsRequest } from './../../store/appActions';

export default function PaymentPendingList() {
    const theme = useTheme();
    const [showAll, setShowAll] = useState(false);
    const dispatch = useDispatch();

    const allTransactions = useSelector((state) => state.app.pendingtransactions || []);

    // console.log('allTransactions :', allTransactions)

    useEffect(() => {
        dispatch(getPendingTransactionsRequest());
    }, [dispatch]);


    const displayedTransactions = showAll ? allTransactions : allTransactions.slice(0, 5);

    return (
        <Card
            sx={{
                p: 2,
                borderRadius: 2,
                boxShadow: theme.shadows[1],
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Typography
                variant="h6"
                fontWeight={theme.typography.h6.fontWeight}
                fontFamily={theme.typography.fontFamily}
                color={theme.palette.text.primary}
                mb={2}
            >
                Pending Payments
            </Typography>

            <List>
                {displayedTransactions.map((tx, index) => (
                    <ListItem key={index} divider sx={{ py: 1 }}>
                        <ListItemText
                            primary={
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography
                                        variant="body1"
                                        fontWeight={500}
                                        fontFamily={theme.typography.fontFamily}
                                        color={theme.palette.text.primary}
                                    >
                                        {tx.patientName}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontFamily={theme.typography.fontFamily}
                                        color={theme.palette.action.purpleDark}
                                    >
                                        {tx.totalDue}
                                    </Typography>
                                </Box>
                            }
                            secondary={
                                <Stack direction="row" alignItems="center" spacing={1} mt={0.5}>
                                    <Chip
                                        size="small"
                                        label="Pending"
                                        sx={{
                                            backgroundColor: theme.palette.action.purpleDark,
                                            color: theme.palette.common.white,
                                            fontWeight: 500,
                                            fontFamily: theme.typography.fontFamily,
                                        }}
                                        icon={<HourglassBottomIcon fontSize="small" sx={{ color: theme.palette.grey[900] }} />}
                                    />
                                </Stack>
                            }
                        />
                    </ListItem>
                ))}
            </List>

            {allTransactions.length > 5 && (
                <Box textAlign="center" mt={1}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? 'View Less' : 'View More'}
                    </Button>
                </Box>
            )}
        </Card>
    );
}
